module.exports = __webpack_public_path__ + "img/stop.ec9692ea.svg";